"use client";

import React from "react";
import { MessageAttachment as UIMessageAttachment } from "@/ui";

interface FilePart {
  type: "file";
  url: string;
  mediaType: string;
  filename?: string;
  name?: string;
}

interface MessageAttachmentProps {
  part: FilePart;
}

export function MessageAttachment({ part }: MessageAttachmentProps) {
  return (
    <UIMessageAttachment
      url={part.url}
      mediaType={part.mediaType}
      filename={part.filename || part.name || "Attachment"}
    />
  );
}
